import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DATA_LICENSE_PUBLIC, DATA_LICENSE_SECTION_TITLE } from '../../consts';
import { ParagraphWithMargin } from '../../containers';
import DescriptionMapper from '../DescriptionMapper';
import Title from '../Title';
const DataLicense = () => (_jsxs(_Fragment, { children: [_jsx(Title, { label: DATA_LICENSE_SECTION_TITLE }, void 0), DATA_LICENSE_PUBLIC.map(({ description, key }) => (_jsx(ParagraphWithMargin, { children: _jsx(DescriptionMapper, { data: description, keyPrefix: key }, void 0) }, key)))] }, void 0));
export default DataLicense;
